import { collection, getDocs } from "firebase/firestore";
import "../style.css";
import React, { useEffect, useState } from "react";
import Nav from "../components/navbar";
import Toptitle from "../components/pagetop";
import { db } from "../firebase-config";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

export default function Explore() {
  const [cats, setCats] = useState([]);

  const fetchCats = async () => {
    const catRef = collection(db, "categories");
    getDocs(catRef).then((response) => {
      const categories = response.docs.map((doc) => ({
        data: doc.data(),
        id: doc.id,
      }));
      setCats(categories);
    });
  };

  useEffect(() => {
    fetchCats();
  }, []);

  return (
    <div className="mainWrapper">
      <Nav />
      <div
        className={`innerwrapper ${
          cats.length > 6 ? "overflow-y-visible p-0" : "overflow-y-hidden p-0"
        }`}
      >
        <Toptitle title="Explore" />
        <div className="flex flex-wrap gap-5 mt-4 px-7 z-10">
          {cats &&
            cats.map((cat, index) => {
              return (
                <motion.div
                  key={index}
                  whileHover={{
                    scale: 1.03,
                    boxShadow: "-2px 0px 30px -24px #666666",
                    transition: { duration: 0.3 },
                  }}
                  animate={{ opacity: 1 }}
                  initial={{ opacity: 0 }}
                  transition={{ ease: "easeOut", duration: 0.5 }}
                  className="basis-[32%] grow relative rounded-lg"
                >
                  <NavLink to={"/explore/" + cat.data.categoryName}>
                    <img
                      src={cat.data.categoryPicture}
                      className=" rounded-lg"
                      alt={cat.data.categoryName}
                    />
                    <div
                      className="absolute top-2/4 left-1/2 text-white font-semibold text-2xl text-center -translate-x-1/2 -translate-y-1/2"
                      key={cat.id}
                    >
                      {cat.data.categoryPicture && cat.data.categoryName}
                    </div>
                  </NavLink>
                </motion.div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
